import {
  PERITADOR_ACT_EXISTING_PATENT_BEGIN,
  PERITADOR_ACT_EXISTING_PATENT_SUCCESS,
  PERITADOR_ACT_EXISTING_PATENT_FAILURE,
  PERITADOR_ACT_EXISTING_PATENT_DISMISS_ERROR
} from './constants'
import { REACT_APP_PERITADOR_API } from '../../../common/config'
import axios from 'axios'

export function actValidateExistingPatent(patente) {
  return dispatch => {
    // optionally you can have getState as the second argument
    dispatch({
      type: PERITADOR_ACT_EXISTING_PATENT_BEGIN
    })
    const promise = new Promise((resolve, reject) => {
      const query = {
        where: {
          servicePatent: patente,
          statusId: {
            inq: ['1','2','3','4','5']
          },
          deletedAt:null
        },
        order: 'serviceDate DESC'
      }
      const fetchUrl = encodeURI(
        `${REACT_APP_PERITADOR_API}/requests?filter=${JSON.stringify(query)}`
      )
      const doRequest = axios(fetchUrl)
      doRequest.then(
        res => {
          if (res.data.length === 0) {
            dispatch({
              type: PERITADOR_ACT_EXISTING_PATENT_SUCCESS,
              data: res
            })
            resolve(res)
          } else {
            dispatch({
              type: PERITADOR_ACT_EXISTING_PATENT_FAILURE,
              data: { 
                error: true,
                message: 'La patente ya está en una solicitud pendiente'  }
            })
          }
        },
        err => {
          dispatch({
            type: PERITADOR_ACT_EXISTING_PATENT_FAILURE,
            data: { error: true, message: 'Algo falló tratando de validar la patente' }
          })
          reject(err)
        }
      )
    })
    return promise
  }
}

export function dismissGetPeritajeError() {
  return {
    type: PERITADOR_ACT_EXISTING_PATENT_DISMISS_ERROR
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PERITADOR_ACT_EXISTING_PATENT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        requestDialogValidateGetPeritadoPending: true,
        requestDialogValidateGetPeritadoError: null
      }

    case PERITADOR_ACT_EXISTING_PATENT_SUCCESS:
      // The request is success
      return {
        ...state,
        requestDialogValidateGetPeritadoPending: false,
        requestDialogValidateGetPeritadoError: null
      }

    case PERITADOR_ACT_EXISTING_PATENT_FAILURE:
      // The request is failed
      return {
        ...state,
        requestDialogValidateGetPeritadoPending: false,
        requestDialogValidateGetPeritadoError: action.data
      }

    case PERITADOR_ACT_EXISTING_PATENT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        requestDialogValidateGetPeritadoError: null
      }

    default:
      return state
  }
}
